module.exports = __webpack_public_path__ + "static/media/Risk-Exclamation.38940545.png";